// extracted by mini-css-extract-plugin
export var styledHeader = "header-module--styledHeader--5e7f6";